module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/grand_jury__02-ca4e11c95f315822557977001e92335f.jpg";